import React from 'react';
import ReactDOM from 'react-dom';
import Main from './components/viewers/main/Main';
import { Provider } from 'react-redux';
import './Style.css';
import { register } from './serviceWorker';
import { transformDataSet } from './utils/transformer';
import { reduxStorage } from './config/redux.store';

const root = document.getElementById('root');

const init = () => {
    const storage = reduxStorage();

    return (
        <Provider store={storage}>
            <Main {...transformDataSet(root.dataset)} />
        </Provider>
    );
};

ReactDOM.render(init(), root);
register();
